<div  class="min-h-screen w-full bg-gradient-to-br from-gray-100 via-slate-100 to-blue-100 flex flex-col">
  <!-- MAIN -->
  <div class="flex-1 flex items-center lg:justify-between justify-center max-w-7xl mx-auto w-full lg:px-12 px-6 flex-col lg:flex-row">
    <!-- LEFT BUTTONS -->
    <div class="flex lg:flex-col flex-row-reverse justify-center gap-6 lg:w-[360px] mb-16 w-full items-center lg:items-start">
      <img src="assets/images/app-downloads/iho-bg.svg" class="lg:w-[72px] lg:h-[72px] w-[32px] h-[32px] lg:mb-5">
      <h1 class="lg:text-[28px] text-xl text-[#002E87] font-medium">
        دانلود اپلیکیشن ایران هتل
      </h1>

    </div>
    <!-- CENTER LOGO -->
    <div class="flex flex-col items-center gap-6 lg:w-[500px] w-full">
      <a href="https://cdn.iranhotelonline.com/Content/iran-hotel-1.0.0.1.apk" class="download-btn">
        <span>
          <img src="assets/images/app-downloads/iho.svg" class="lg:w-[48px] lg:h-[48px] w-[32px] h-[32px] ml-3 inline-block">
          دانلود با لینک مستقیم</span>
        <i class="ico-Download"></i>
      </a>
      <a href="https://cafebazaar.ir/app/com.iranhotelonline.twa" class="download-btn">
        <span>
          <img src="assets/images/app-downloads/bazar.svg" class="lg:w-[48px] lg:h-[48px] w-[32px] h-[32px] ml-3 inline-block">
          دانلود از کافه بازار
          
        </span>
        <i class="ico-Download"></i>
      </a>

      <a href="#" class="download-btn">
        <span>
          <img src="assets/images/app-downloads/myket.svg" class="lg:w-[48px] lg:h-[48px] w-[32px] h-[32px] ml-3 inline-block">
          دانلود از مایکت

        </span>
        <i class="ico-Download"></i>
      </a>

      <a href="#" class="download-btn">
        <span>
          <img src="assets/images/app-downloads/apple.svg" class="lg:w-[48px] lg:h-[48px] w-[32px] h-[32px] ml-3 inline-block">

          دانلود از سیب اپ</span>
        <i class="ico-Download"></i>
      </a>


    </div>




  </div>
</div>